import { motion } from 'framer-motion';
import { personalData } from '../data/content';
import { Briefcase, Calendar, CheckCircle2 } from 'lucide-react';

export default function Experience() {
  return (
    <section id="experience" className="py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Professional Journey</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A timeline of my work in operations, IT leadership, and community advocacy.
          </p>
        </motion.div>

        <div className="relative border-l-2 border-emerald-200 ml-4 md:ml-0 space-y-12">
          {personalData.experience.map((job, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative pl-8 md:pl-0"
            >
              {/* Timeline Dot */}
              <div className="absolute -left-[9px] top-0 w-5 h-5 rounded-full bg-emerald-500 border-4 border-white shadow-sm md:left-1/2 md:-ml-[10px]" />

              <div className={`md:flex items-start justify-between ${index % 2 === 0 ? 'md:flex-row-reverse' : ''} group`}>
                {/* Content Card */}
                <div className={`md:w-[45%] mb-2 md:mb-0 ${index % 2 === 0 ? 'md:text-left' : 'md:text-right'}`}>
                  <div className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100">
                    <div className={`flex items-center gap-2 mb-2 text-emerald-600 text-sm font-medium ${index % 2 === 0 ? '' : 'md:justify-end'}`}>
                      <Calendar size={16} />
                      {job.period}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-1">{job.role}</h3>
                    <h4 className="text-lg text-gray-700 mb-3 font-medium">{job.company}</h4>
                    <p className="text-gray-600 leading-relaxed text-sm mb-4">
                      {job.description}
                    </p>
                    
                    {/* Achievements List */}
                    {job.achievements && job.achievements.length > 0 && (
                      <ul className={`space-y-2 text-sm text-gray-500 ${index % 2 === 0 ? 'text-left' : 'md:text-right text-left'}`}>
                        {job.achievements.map((achievement, i) => (
                          <li key={i} className={`flex items-start gap-2 ${index % 2 === 0 ? '' : 'md:flex-row-reverse'}`}>
                            <CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" />
                            <span>{achievement}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                
                {/* Spacer for the other side */}
                <div className="md:w-[45%]" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
